import { Attribution, AttributionLink } from '@99designs/emu';
import { FormattedReactMessage, formatMessage } from '@99designs/frontend-components/i18n';

interface CustomerAttributionProps {
    text: string;
    link?: string;
}

export function ContestCustomerAttribution({ text, link }: CustomerAttributionProps) {
    if (link) {
        return (
            <Attribution>
                <FormattedReactMessage
                    message={__('Design contest for <CustomerLink>{customerName}</CustomerLink>')}
                    values={{ customerName: text }}
                    replacements={{
                        CustomerLink: <AttributionLink href={link} />,
                    }}
                />
            </Attribution>
        );
    }

    return (
        <Attribution>
            {formatMessage(__('Design contest for {customerName}'), {
                customerName: text,
            })}
        </Attribution>
    );
}

export function CustomerAttribution({ text, link }: CustomerAttributionProps) {
    if (link) {
        return (
            <Attribution>
                <FormattedReactMessage
                    message={__('Design for <CustomerLink>{customerName}</CustomerLink>')}
                    values={{ customerName: text }}
                    replacements={{
                        CustomerLink: <AttributionLink href={link} />,
                    }}
                />
            </Attribution>
        );
    }

    return (
        <Attribution>
            {formatMessage(__('Design for {customerName}'), {
                customerName: text,
            })}
        </Attribution>
    );
}
